import { render } from "./TilesSection.vue?vue&type=template&id=4a990ff5&ts=true"
import script from "./TilesSection.vue?vue&type=script&lang=ts"
export * from "./TilesSection.vue?vue&type=script&lang=ts"

import "./TilesSection.vue?vue&type=style&index=0&id=4a990ff5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__